<template>
  <div
    v-show="windowScrollTop > 100"
    class="mobileFloatingCta animate__fadeIn animate--faster mobileFloatingCta1 mobileFloatingCta--1 lp-section width-expand relative z-level-top1"
    :id="`MobileFloatingCta1-${pageUid}`">
    <div class="spacer l:hidden" style="height: var(--margin-2xl)"></div>
   <div class="floating-cta-wrapper flex-center  z-level-2 fixed-bottom-strip l:hidden cursor-pointer transition">
     <form-button v-bind="button" class="width-expand" style="border-radius: 0;"
                  @click="track('mobileFloatingCta1',{value:button.text}).then(button.navigationHandler)"
     ></form-button>
   </div>
  </div>
</template>

<script>
import useUiElements from "@/client/extensions/composition/useUiElements";
import lpSectionMixin from "@/client/applications/meitavlp/extensions/mixins/lpSection";
import { inject } from "vue";
import useDom from "@/client/extensions/composition/useDom";

export default {
  mixins: [lpSectionMixin],

  setup(props) {
    let pageUid = inject("pageUid");
    let {windowScrollTop} = useDom();
    let schema = {
      button: {},
    };
    let overloadedProps = useUiElements({ input: props.sectionData }).props;
    return {
      ...schema,
      ...overloadedProps,
      allData: overloadedProps,
      pageUid,
      trackEvent: inject("trackEvent"),
      track: inject("track"),
      triggerSectionsEvent: inject("triggerSectionsEvent"),
      windowScrollTop,
    };
  },
  data: function () {
    return {
      isOpened: false,
    };
  },
  computed: {
    mobileTopProperty() {
      return `${this.topOffset}px`;
    },
  },
  methods: {

  },
};
</script>

<style scoped lang="scss">
.mobileFloatingCta1 {

  .floating-cta-wrapper {
    &:hover {
      opacity: 0.95;
    }
  }
}
</style>
